import { createI18n } from 'vue-i18n'

import { SUPPORTED_LANGUAGES } from '@/config/constants'

const FALLBACK_LANGUAGE = 'de'

const browserLanguage = document.documentElement.getAttribute('lang')?.toLowerCase()
const selectedLanguage = SUPPORTED_LANGUAGES.map(s => s.value).includes(browserLanguage)
  ? browserLanguage
  : FALLBACK_LANGUAGE

const i18n = createI18n({
  globalInjection: true,
  legacy: false,
  locale: selectedLanguage,
  warnHtmlMessage: false,
})

export default function useI18n() {
  return {
    i18n,
    t: i18n.global.t,
    tm: i18n.global.tm,
    te: i18n.global.te,
    locale: i18n.global.locale,
    browserLanguage,
    selectedLanguage,
  }
}
